<template>
<div class="selfie-container">
  <b-tabs v-if="dados" :no-nav-style="true">
    <b-tab :title="v.name" active v-for="v in dados.validations" v-bind:key="v.id">
      <b-form-group
        label="Link"
        label-for="shortenUrl"
        :label-cols="3"
        :horizontal="true"
        v-if="v.shortenUrl">
        <b-input-group>
          <b-form-input plaintext id="shortenUrl" type="text" :value="v.shortenUrl"></b-form-input>
          <b-button variant="outline-success" class="mr-1" :href="v.whatsappLink" target="_blank"><i class="micon-whatsapp"></i></b-button>
          <b-button variant="outline-success" class="mr-1"  @click="sendWhatsappMessage(v.whatsappMessage)">
            Novo<br><i class="micon-whatsapp" v-if="!loading"></i>
            <b-spinner v-if="loading" small class="whatsapp-message-loading"/>
          </b-button>
        </b-input-group>
      </b-form-group>
      <b-form-group
        class="font-weight-bold h4"
        label="Dispositivo (SO)"
        label-for="os"
        :label-cols="3"
        :horizontal="true"
        v-if="v.device">
        <b-form-input class="font-weight-bold h4" plaintext id="os" type="text" :value="v.device.os"></b-form-input>
      </b-form-group>

      <div class="d-flex align-items-center">
        <viewer :images="images" class="images clearfix">
          <div v-for="src in v.images" v-bind:key="src" style="padding: 15px; cursor: pointer; color: #FA0F00;">
            <div v-if="src.type === 'application/pdf' && src" class="text-center">
              <a @click="openPDF(src.data)" :alt="src.title"><i class="fa fa-file-pdf-o fa-5x"></i></a>
              <p class="mt-2 text-center">Comprovante de<br /> residência</p>
            </div>
            <img v-else :src="src.data" class="image" :alt="src.title">
          </div>
        </viewer>

        <div v-if="v.name === 'Jornada' && video">
          <video :src="getVideo()" controls id="selfieVideo" class="selfieVid show"/>
        </div>

        <div v-if="v.video">
          <video :src="v.video" controls class="selfieVid show"/>
        </div>
      </div>

      <div class="row" style="margin-left: 5px; margin-bottom: 5px;">
        <div style="margin-left: 5px; margin-bottom: 5px;" v-if="(!v.results.data || v.results.data.length < 5) && (v.images && v.images.length > 0)">
          <b-button class="btn btn-primary mb-4" style="color: #FFF" @click="verify(v.uuid)">Verificar Serpro</b-button>
        </div>
        <div style="margin-left: 5px; margin-bottom: 5px;">
          <b-button class="btn btn-primary mb-4" style="color: #FFF" v-b-modal.modal-documento-validate v-if="v.images && v.images.length > 0">Validar documento</b-button>
        </div>
        <div style="margin-left: 5px; margin-bottom: 5px;">
          <b-button class="btn btn-primary mb-4" style="color: #FFF" v-b-modal.modal-document-catalog v-if="v.images && v.images.length > 0 && v.transactionValidationFilesId" @click="getValidationAndValidationFilesId(v.transactionValidationId, v.transactionValidationFilesId); getDocumentImages(v.images)">Cadastrar no catálogo</b-button>
        </div>
      </div>
      <div v-if="refreshData">
        <b-button class="btn btn-primary mb-4" style="color: #FFF" @click="loadData">Atualizar dados</b-button>
      </div>

      <div v-if="v.results.data">
        <b-row>
          <b-col sm="12" md="12" v-for="r in v.results.data" v-bind:key="r.id">
            <div class="box mb-4">
              <div class="wrapper d-flex justify-content-between align-items-center">
                <h4 class="font-weight-bold m-0">{{ r.step }}</h4>

                <div class="wrapper d-flex align-items-center">
                  <span class="badge badge-success badge-md" v-if="r.status === 'OK'">OK</span>
                  <span class="badge badge-danger badge-md" v-else-if="r.status === 'ERROR'">ERROR</span>
                  <span class="badge badge-warning badge-md" v-else-if="r.status === 'REVIEW'">REVIEW</span>
                  <span class="badge badge-warning badge-md" v-else >{{ r.status }}</span>
                  <div class="dropdown ml-2">
                    <button class="btn btn-bare dropdown-toggle p-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <b-btn class="dropdown-item" v-b-toggle="'validation-' + r.step" variant="">DEBUG</b-btn>
                    </div>
                  </div>
                </div>

              </div>
              <div class="mt-3">
                <b-collapse :id="'validation-' + r.step" class="mt-2">
                  <div class="custom-container mb-3">
                    <button class="btn p-2 float-right" v-b-toggle="'validation-' + r.step" variant=""><i class="fa fa-times"></i></button>
                    <div style="max-width: 600px;">
                      <p class="card-text"><pre><code>{{ r }}</code></pre></p>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!--
            <b-card>
              <div slot="header">
                {{ r.step}}
                <b-badge variant="success" class="float-right" v-if="r.status === 'OK'">{{ r.status }}</b-badge>
                <b-badge variant="danger" class="float-right" v-else-if="r.status === 'ERROR'">{{ r.status }}</b-badge>
                <b-badge variant="warning" class="float-right" v-else>{{ r.status }}</b-badge>
              </div>
              <b-btn v-b-toggle="'validation-' + r.step" variant="">DEBUG</b-btn>
              <b-collapse :id="'validation-' + r.step" class="mt-2">
                <b-card>
                  <p class="card-text"><pre><code>{{ r}}</code></pre></p>
                </b-card>
              </b-collapse>
            </b-card>
            -->
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row>
          <b-col sm="12" md="12" v-for="r in v.results" v-bind:key="r.id">
            <div class="box mb-4">
              <div class="wrapper d-flex justify-content-between align-items-center">
                <h4 class="font-weight-bold m-0">{{ r.step }}</h4>

                <div class="wrapper d-flex align-items-center">
                  <span class="badge badge-success badge-md" v-if="r.status === 'OK'">OK</span>
                  <span class="badge badge-danger badge-md" v-else-if="r.status === 'ERROR'">ERROR</span>
                  <span class="badge badge-warning badge-md" v-else-if="r.status === 'REVIEW'">REVIEW</span>
                  <span class="badge badge-warning badge-md" v-else >{{ r.status }}</span>
                  <div class="dropdown ml-2">
                    <button class="btn btn-bare dropdown-toggle p-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <b-btn class="dropdown-item" v-b-toggle="'validation-' + r.step" variant="">DEBUG</b-btn>
                    </div>
                  </div>
                </div>

              </div>
              <div class="mt-3">
                <b-collapse :id="'validation-' + r.step" class="mt-2">
                  <div class="custom-container mb-3">
                    <button class="btn p-2 float-right" v-b-toggle="'validation-' + r.step" variant=""><i class="fa fa-times"></i></button>
                    <div style="max-width: 600px;">
                      <p class="card-text"><pre><code>{{ r }}</code></pre></p>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <!--
            <b-card>
              <div slot="header">
                {{ r.step}}
                <b-badge variant="success" class="float-right" v-if="r.status === 'OK'">{{ r.status }}</b-badge>
                <b-badge variant="danger" class="float-right" v-else-if="r.status === 'ERROR'">{{ r.status }}</b-badge>
                <b-badge variant="warning" class="float-right" v-else>{{ r.status }}</b-badge>
              </div>
              <b-btn v-b-toggle="'validation-' + r.step" variant="">DEBUG</b-btn>
              <b-collapse :id="'validation-' + r.step" class="mt-2">
                <b-card>
                  <p class="card-text"><pre><code>{{ r}}</code></pre></p>
                </b-card>
              </b-collapse>
            </b-card>
            -->
          </b-col>
        </b-row>
      </div>
    </b-tab>
    <template v-slot:tabs-end>
      <!--
      <b-nav-item href="#" id="popover-target-1" v-if="createLoading"><b-spinner type="border" small></b-spinner></b-nav-item>
      <b-nav-item @click.prevent="createVerification" href="#" id="popover-target-1" v-else :disabled="disabledSplit"><b>+</b></b-nav-item>
      <b-popover v-if="!disabledSplit" target="popover-target-1" triggers="hover" placement="top">
        <template v-slot:title>Criar nova verificação</template>
        Se ainda estiver faltando dados para poder aprovar/reprovar, crie uma nova verificação
      </b-popover>
      -->
    </template>
    <b-modal
      id="modal-document-catalog"
      size="xl"
      no-close-on-esc
      ref="modal-catalog"
      title="Cadastrar documento"
      @show="resetModalCatalog"
      @hidden="resetModalCatalog"
      @ok="saveDocument"
      cancel-title="Cancelar"
      ok-title="Salvar"
    >
      <form ref="catalog-form">
        <div class="d-flex container">
          <div style="width: 60%">
            <b-form-group
              label="Número do Documento"
              label-for="documentNumber-input"
            >
              <b-form-input
                id="documentNumber-input"
                v-model="catalogForm.documentNumber"
              ></b-form-input>
            </b-form-group>
            <div class="row">
              <div class="col-sm">
                <b-form-group
                  label="Data de Nascimento"
                  label-for="birthDate-input"
                >
                  <b-form-input
                    id="birthDate-input"
                    v-model="catalogForm.birthDate"
                    v-mask="'##/##/####'"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm">
                <b-form-group
                  label="Data de emissão"
                  label-for="issueDate-input"
                >
                  <b-form-input
                    id="issueDate-input"
                    v-model="catalogForm.issueDate"
                    v-mask="'##/##/####'"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <b-form-group
              label="Estado de emissão"
              label-for="issuingState-input"
            >
              <b-form-select v-model="catalogForm.issuingState" :options="estadosEmissao"></b-form-select>
            </b-form-group>
            <b-form-group
              label="Órgão expedidor"
              label-for="issuingState-input"
            >
              <b-form-input
                id="orgaoExpedidor-input"
                v-model="catalogForm.issuingAuthority"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="Tipo do documento"
              label-for="documentType-input"
            >
              <b-form-select v-model="catalogForm.documentType" :options="documentTypeList"></b-form-select>
            </b-form-group>
          </div>
          <div>
            <b-form-group>
              <viewer class="images clearfix">
                <div v-for="src in documentImages" :key="src">
                  <img :src="src.data" class="image" v-if="src.title !== 'Selfie'">
                </div>
              </viewer>
            </b-form-group>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="modal-documento-validate"
      ref="modal"
      title="Validar Documento SERPRO"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="documentValidate">
        <b-form-group
          :state="numeroDocumentoState"
          label="Número do Documento"
          label-for="numeroDocumento-input"
          invalid-feedback="Número do documento é obrigatório"
        >
          <b-form-input
            id="numeroDocumento-input"
            v-model="form.numeroDocumento"
            :state="numeroDocumentoState"
            required
          ></b-form-input>
        </b-form-group>
        <div class="row">
          <div class="col-sm">
            <b-form-group
              :state="dtNascimentoState"
              label="Data de Nascimento"
              label-for="dataNascimento-input"
              invalid-feedback="Data de nascimento é obrigatório"
            >
              <b-form-input
                id="dataNascimento-input"
                v-model="form.dtNascimento"
                :state="dtNascimentoState"
                v-mask="'##/##/####'"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm">
            <b-form-group
              :state="dtEmissaoState"
              label="Data de emissão"
              label-for="dataEmissao-input"
              invalid-feedback="Data de emissão é obrigatório"
            >
              <b-form-input
                id="dataEmissao-input"
                v-model="form.dtEmissao"
                :state="dtEmissaoState"
                v-mask="'##/##/####'"
                required
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <b-form-group
          :state="estadoEmissaoState"
          label="Estado de emissão"
          label-for="estadoEmissao-input"
          invalid-feedback="Estado de emissão é obrigatório"
        >
          <b-form-select v-model="form.estadoEmissaoSelected" :state="estadoEmissaoState" :options="estadosEmissao"></b-form-select>
        </b-form-group>
        <b-form-group
          :state="orgaoExpedidorState"
          label="Órgão expedidor"
          label-for="orgaoExpedidor-input"
          invalid-feedback="Órgão expedidor é obrigatório"
        >
          <b-form-input
            id="orgaoExpedidor-input"
            v-model="form.orgaoExpedidor"
            :state="orgaoExpedidorState"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          :state="tipoDocumentoState"
          label="Tipo do documento"
          label-for="tipoDocumento-input"
          invalid-feedback="O tipo de documento é obrigatório"
        >
          <b-form-select v-model="form.tipoDocumentoSelected" :state="tipoDocumentoState" :options="tiposDocumento"></b-form-select>
        </b-form-group>
      </form>
    </b-modal>
  </b-tabs>
</div>
</template>
<script>
import 'viewerjs/dist/viewer.css'

export default {
  props: [],
  components: {

  },
  data () {
    return {
      catalogForm: {
        documentNumber: null,
        birthDate: null,
        issueDate: null,
        issuingState: null,
        issuingAuthority: null,
        documentType: null,
        transactionValidationId: null,
        transactionValidationFilesId: null
      },
      documentImages: [],
      documentTypeList: [
        { value: null, text: 'Selecione um documento' },
        { value: 'ID_CARD', text: 'Carteira de identidade' },
        { value: 'WORK_CARD', text: 'Carteira profissional' },
        { value: 'PASSPORT', text: 'Passaporte' },
        { value: 'RESERVIST_CARD', text: 'Carteira de reservista' }
      ],
      form: {
        numeroDocumento: '',
        dtNascimento: '',
        dtEmissao: '',
        estadoEmissaoSelected: null,
        orgaoExpedidor: '',
        tipoDocumentoSelected: null,
        fileUuid: null
      },
      numeroDocumentoState: null,
      dtNascimentoState: null,
      dtEmissaoState: null,
      estadoEmissaoState: null,
      estadosEmissao: [
        { value: null, text: 'Selecione um estado' },
        { value: 'AC', text: 'Acre' },
        { value: 'AM', text: 'Amazonas' },
        { value: 'AP', text: 'Amapá' },
        { value: 'BA', text: 'Bahia' },
        { value: 'CE', text: 'Ceará' },
        { value: 'DF', text: 'Distrito Federal' },
        { value: 'ES', text: 'Espírito Santo' },
        { value: 'GO', text: 'Góias' },
        { value: 'MA', text: 'Maranhão' },
        { value: 'MG', text: 'Minas Gerais' },
        { value: 'MS', text: 'Mato Grosso do Sul' },
        { value: 'MT', text: 'Mato Grosso' },
        { value: 'PA', text: 'Pará' },
        { value: 'PB', text: 'Paraíba' },
        { value: 'PE', text: 'Pernambuco' },
        { value: 'PI', text: 'Piauí' },
        { value: 'PR', text: 'Paraná' },
        { value: 'RJ', text: 'Rio de Janeiro' },
        { value: 'RN', text: 'Rio Grande do Norte' },
        { value: 'RO', text: 'Rondônia' },
        { value: 'RR', text: 'Roraima' },
        { value: 'RS', text: 'Rio Grande do Sul' },
        { value: 'SC', text: 'Santa Catarina' },
        { value: 'SE', text: 'Sergipe' },
        { value: 'SP', text: 'São Paulo' },
        { value: 'TO', text: 'Tocantins' }
      ],
      orgaoExpedidorState: null,
      tipoDocumentoState: null,
      tiposDocumento: [
        { value: null, text: 'Selecione um documento' },
        { value: 1, text: 'Carteira de identidade' },
        { value: 2, text: 'Carteira profissional' },
        { value: 3, text: 'Passaporte' },
        { value: 4, text: 'Carteira de reservista' }
      ],
      dados: null,
      createLoading: false,
      refreshData: false,
      video: null,
      loading: false,
      disabledSplit: false
    }
  },
  methods: {
    openPDF (pdf) {
      let pdfWindow = window.open('', '', 'width=1200,height=700')
      pdfWindow.document.write(
        "<title>Comprovante de residência</title><iframe width='100%' height='100%' src='" + encodeURI(pdf) + "'></iframe>"
      )
      return false
    },
    getVideo () {
      return this.video
    },
    loadVideo () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/video')
        .then(function (res) {
          this.video = res.data.video
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          document.getElementById('selfieVideo').className = 'hide'
        })
    },
    getDocumentImages (images) {
      this.documentImages = images
    },
    getValidationAndValidationFilesId (transactionValidationId, transactionValidationFilesId) {
      this.catalogForm.transactionValidationId = transactionValidationId
      this.catalogForm.transactionValidationFilesId = transactionValidationFilesId
    },
    saveDocument () {
      if (this.catalogForm.birthDate) {
        this.catalogForm.birthDate = this.formatStringDate(this.catalogForm.birthDate)
      }
      if (this.catalogForm.issueDate) {
        this.catalogForm.issueDate = this.formatStringDate(this.catalogForm.issueDate)
      }

      this.$http.post('api/documentCatalog', this.catalogForm)
        .then(function (res) {
          this.$bvToast.toast('Documento salvo com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res, {
            title: 'Erro ao salvar documento',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    resetModalCatalog () {
      this.catalogForm.documentNumber = null
      this.catalogForm.birthDate = null
      this.catalogForm.issueDate = null
      this.catalogForm.issuingState = null
      this.catalogForm.issuingAuthority = null
      this.catalogForm.documentType = null
      this.transactionValidationId = null
      this.transactionValidationFilesId = null
    },
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.numeroDocumentoState = valid
      this.numeroDocumentoState = valid
      this.dtNascimentoState = valid
      this.dtEmissaoState = valid
      this.estadoEmissaoState = valid
      this.orgaoExpedidorState = valid
      this.tipoDocumentoState = valid
      return valid
    },
    resetModal () {
      this.numeroDocumento = ''
      this.numeroDocumentoState = null
    },
    handleOk (e) {
      e.preventDefault()
      this.documentValidate()
    },
    documentValidate () {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      let id = this.dados.validations.map(dado => dado.uuid)
      this.form.fileUuid = id[1]
      console.log(this.form)
      this.$http.post('api/validations/validateDocument', this.form)
        .then(function (res) {
          this.$bvToast.toast('Validação feita com sucesso', {
            title: 'Validação de documento',
            autoHideDelay: 5000,
            variant: 'success'
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res, {
            title: 'Erro ao validar documento',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    loadData () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/data')
        .then(function (res) {
          this.dados = res.data
          var allImages = []
          if (this.dados.profile.image) {
            allImages.push(this.dados.profile.image)
          }
          // for (var i = 0; i < this.dados.validations.length; i++) {
          //   var v = this.dados.validations[i]
          //   if (v.images) {
          //     allImages.push.apply(allImages, v.images)
          //   }
          // }
          this.createLoading = false
          this.$emit('onloadimages', allImages)
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    verify (uuid) {
      var url = 'api/validations/' + this.$route.params.txid + '/verify'
      if (uuid) {
        url += '?files=true&uuidFile=' + uuid
      }
      this.$http.post(url)
        .then(function (res) {
          this.refreshData = true
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    createVerification () {
      this.createLoading = true
      this.$http.post('api/validations/' + this.$route.params.txid)
        .then(function (res) {
          this.loadData()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.msgErro = res.data
        })
    },
    sendWhatsappMessage (msg) {
      if (!this.loading) {
        this.loading = true
        this.$http.get('api/transactions/' + this.$route.params.txid)
          .then(function (res) {
            var transaction = res.data.tx.id
            var selectedPhone = res.data.data.data.buyer.phoneNumber
            this.$http.post('api/chat', {message: msg, phone: selectedPhone.toString(), transaction: transaction, username: this.$auth.user().username})
              .then(function (res) {
                this.verifyProtocol(res.data.protocol)
                this.$bvToast.toast('Mensagem enviada com sucesso', {
                  autoHideDelay: 5000,
                  variant: 'success'
                })
                this.$root.$emit('updateWhatsappMessages')
                this.loading = false
              })
              .catch(function (res) {
                this.$bvToast.toast('Erro ao enviar mensagem', {
                  autoHideDelay: 5000,
                  variant: 'danger'
                })
                console.log('Error')
                console.log(res)
                this.loading = false
              })
          })
          .catch(function (res) {
            console.log('Error')
            console.log(res)
            this.loading = false
          })
      }
    },
    verifyProtocol (protocol) {
      this.$http.get('api/protocol/number/' + protocol)
        .then(function (res) {
          var userProtocol = res.data.protocolNumber.user
          if (userProtocol === undefined) {
            this.assignToMe(protocol)
          } else {
            this.$http.get('api/me/')
              .then(function (res) {
                if (userProtocol !== res.data.id) {
                  this.$bvModal.msgBoxConfirm('Você deseja ASSUMIR este atendimento?', {
                    title: 'ASSUMIR ATENDIMENTO',
                    size: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM, assumir',
                    cancelTitle: 'Não',
                    footerClass: 'p-2',
                    hideHeaderClose: false
                  })
                    .then(value => {
                      if (value === true) {
                        this.assignToMe(protocol)
                      }
                    })
                    .catch(err => {
                      console.log('Error: ' + err)
                    })
                }
              })
              .catch(function (res) {
                console.log('Error')
                console.log(res)
              })
          }
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    assignToMe (protocol) {
      this.$http.put('api/protocol/' + protocol + '/' + '1/' + this.$auth.user().username)
        .then(function (res) {
          this.$bvToast.toast('Atendimento atribuído com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    formatStringDate (date) {
      var day = date.split('/')[0]
      var month = date.split('/')[1]
      var year = date.split('/')[2]

      return year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2)
    }
  },
  mounted () {
    this.loadData()
    this.loadVideo()
    this.$root.$on('disabledSplit', () => {
      this.disabledSplit = true
    })
  },
  watch: {
    '$route.params.txid' () {
      this.loadData()
      this.loadVideo()
    }
  }
}
</script>
<style lang="css">
  .image {
    height: 200px;
    cursor: pointer;
    margin: 5px;
    display: inline-block;
  }
  .selfieVid {
    height: 200px;
    max-width: 270px;
    margin: 5px;
    display: inline-block;
  }
  .hide{
    display:none;
  }
  .show{
      display:block;
  }
  .nav-tabs .nav-link.disabled {
    opacity: 0.65 !important;
    cursor: not-allowed !important;
    pointer-events: all !important;
  }
  .tab-content {
    background: #fff !important;
    border: 1px solid #FFF !important;
  }
  .selfie-container .nav-item .nav-link.active {
    color: #313A70 !important;
    font-weight: 600 !important;
    border-bottom: 5px solid #00C25A !important;
    border-radius: 0 0 5px 5px;
    background: #fff !important;
    border-top-color: #FFF !important;
    border-left-color: #FFF !important;
    border-right-color: #FFF !important;
  }
  .selfie-container .nav-item a {
    color: #a3a3a3 !important;
    text-decoration: none !important;
    background-color: transparent !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/validations/ValidationShow.vue